import { Link } from '@/i18n/navigation'
import { cn } from '@/lib/utils'

import { TeamPayLogo } from '../icons/TeamPayLogo'

interface IBrandLogoProps {
  mode: 'light' | 'dark'
  className?: string
  size?: string
  height?: string
}

export function BrandLogo({
  mode = 'dark',
  className,
  size = '100px',
  height = '17px'
}: IBrandLogoProps) {
  return (
    <div>
      <Link href="/" aria-label="Home">
        <TeamPayLogo
          size={size}
          height={height}
          className={cn(
            mode === 'dark' ? 'text-primary-500' : 'text-white',
            className
          )}
        />
      </Link>
    </div>
  )
}
